// extracted by mini-css-extract-plugin
module.exports = {"item":"TeamItem_item__EnLed","add":"TeamItem_add__5VrXF","remove":"TeamItem_remove__T0JF4","tooltip":"TeamItem_tooltip__jqY6g"};